export default __webpack_public_path__ + "static/media/error404_light.f91ec09b.svg";